/**
 * Defines all different kinds of aggregate types.
 *
 * !!!
 * IMPORTANT: This enum is also defined in the following repositories: inspector-app, backoffice-backend => keep the versions synchronized
 * !!!
 */
export enum AggregateType {
  RLT_SUPPLY_AIR = 'RLT_SUPPLY_AIR',
  RLT_EXHAUST_AIR = 'RLT_EXHAUST_AIR',
  RLT_CIRCULATING_AIR = 'RLT_CIRCULATING_AIR',
  SHARED_AIR_INTAKE = 'SHARED_AIR_INTAKE',
  COMPACT_UNIT = 'COMPACT_UNIT',
  SPLIT_UNIT = 'SPLIT_UNIT',
  RECIRCULATION_COOLING_UNIT = 'RECIRCULATION_COOLING_UNIT',
  RECIRCULATION_HEATING_UNIT = 'RECIRCULATION_HEATING_UNIT',
  DOOR_AIR_CURTAIN = 'DOOR_AIR_CURTAIN',
  CEILING_CASSETTE = 'CEILING_CASSETTE',
  CLIMATE_CABINET = 'CLIMATE_CABINET',
  COOLING_TOWER_OPEN = 'COOLING_TOWER_OPEN',
  COOLING_TOWER_CLOSED = 'COOLING_TOWER_CLOSED',
  COOLING_TOWER_HYBRID = 'COOLING_TOWER_HYBRID',
  WET_SEPARATOR = 'WET_SEPARATOR',
  SPLIT_SYSTEM = 'COMPRESSION_REFRIGERATION_SYSTEM,',
  MULTI_SPLIT_SYSTEM = 'MULTI_SPLIT_SYSTEM',
  VRF_SYSTEM = 'VRF_SYSTEM',
  COMPRESSION_REFRIGERATOR = 'COMPRESSION_REFRIGERATOR'
}

export const AggregateTypeLabels: {
  [key in AggregateType]: string;
} = {
  [AggregateType.RLT_SUPPLY_AIR]: 'RLT-Zuluft',
  [AggregateType.RLT_EXHAUST_AIR]: 'RLT-Abluft',
  [AggregateType.RLT_CIRCULATING_AIR]: 'RLT-Umluft',
  [AggregateType.SHARED_AIR_INTAKE]: 'Gem. AU',
  [AggregateType.COMPACT_UNIT]: 'Kompaktanlage',

  [AggregateType.CEILING_CASSETTE]: 'Deckenkassette',
  [AggregateType.CLIMATE_CABINET]: 'Klimaschrank',
  [AggregateType.SPLIT_UNIT]: 'Splitgerät',
  [AggregateType.DOOR_AIR_CURTAIN]: 'Tür- / Torluftschleier',
  [AggregateType.RECIRCULATION_HEATING_UNIT]: 'Umluftheizgerät',
  [AggregateType.RECIRCULATION_COOLING_UNIT]: 'Umluftkühlgerät',

  [AggregateType.COOLING_TOWER_OPEN]: 'Kühlturm (offen)',
  [AggregateType.COOLING_TOWER_CLOSED]: 'Kühlturm (geschlossen)',
  [AggregateType.COOLING_TOWER_HYBRID]: 'Kühlturm (hybrid)',
  [AggregateType.WET_SEPARATOR]: 'Nassabscheider',

  /** Describes the whole system of a split unit with its outside cooling unit */
  [AggregateType.SPLIT_SYSTEM]: 'Split-System',
  [AggregateType.MULTI_SPLIT_SYSTEM]: 'Multi-Split-System',

  /** Variable Refrigerant Flow systems*/
  [AggregateType.VRF_SYSTEM]: 'VRF-System',

  [AggregateType.COMPRESSION_REFRIGERATOR]: 'Kompressionskältemaschine',
};
